import { Record, List } from 'immutable';

export const NodeModel = Record({
  objectID: '',
  parentID: null,
  childrensID: List([]),
});
